import { useMutation, useQueryClient } from 'react-query';
import * as teamsApi from 'resources/teams/teams.api';
import uiNotifications from 'services/uiNotification.service';

export default function useUpdateTeam() {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useMutation(
    (data) => teamsApi.updateTeam(data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['teams.get-teams', currentUser.company_id]);
        queryClient.invalidateQueries(['teams.get-team-by-id', data.id]);
        uiNotifications.showSuccess('Team updated successfully');
      },
    },
  );
}
